import React, { Component } from 'react'
import './style.css'

import { SortableContainer, SortableElement } from 'react-sortable-hoc'
import Container from './SortableContainer'

export const SortableItem = SortableElement((props) => (
	<Container
		{...props}
		courseId={props.courseId}
		courseContent={props.courseContent}
		position={props.position}
		language={props.language}
		setContentQuizEditing={props.setContentQuizEditing}
	/>
))

export const SortableList = SortableContainer(
	({
		content,
		deleteContent,
		courseId,
		language,
		language_id,
		setContentQuizEditing,
	}) => {
		return (
			<div className='sortable-items-wrapper'>
				{content.length
					? content.map((item, index) => (
							<SortableItem
								{...item}
								courseId={courseId}
								deleteContent={deleteContent}
								courseContent={content}
								key={`item-${item.id}`}
								position={item.position}
								index={index}
								type={item.type}
								language={language}
								language_id={language_id}
								setContentQuizEditing={setContentQuizEditing}
							/>
					  ))
					: null}
			</div>
		)
	}
)

export default class SortableContent extends Component {
	state = {
		content: this.props.content,
	}

	onSortEnd = ({ oldIndex, newIndex }) => {
		this.props.onReorder(oldIndex, newIndex)
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			content: nextProps.content,
		})
	}

	render() {
		return (
			<SortableList
				content={this.state.content}
				lockAxis='y'
				axis='y'
				onSortEnd={this.onSortEnd}
				transitionDuration={300}
				deleteContent={this.props.deleteContent}
				courseId={this.props.courseId}
				distance={1}
				language={this.props.language}
				language_id={this.props.language_id}
				setContentQuizEditing={this.props.setContentQuizEditing}
			/>
		)
	}
}
